import React, { useState } from "react";
import { Checkbox, ListItemText, MenuItem, Popover } from "@material-ui/core";
import FilterListIcon from "@mui/icons-material/FilterList";

const StatusFilterHeader = ({ label, statuses, value, onChange, renderBadge }) => {
  const [anchor, setAnchor] = useState(null);

  const toggle = (status) =>
    onChange(value.includes(status) ? value.filter((x) => x !== status) : [...value, status]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <span style={{ fontWeight: 600, fontSize: 13, color: "#54606F" }}>{label}</span>
      <FilterListIcon
        onClick={(e) => { e.stopPropagation(); setAnchor(e.currentTarget); }}
        style={{ fontSize: 16, cursor: "pointer", color: value.length > 0 ? "#2960EE" : "#54606F" }}
      />
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ style: { borderRadius: 10, padding: "4px 0", minWidth: 220 } }}
      >
        {statuses.map((s) => (
          <MenuItem key={s} onClick={() => toggle(s)} style={{ padding: "6px 14px" }}>
            <Checkbox checked={value.includes(s)} color="primary" size="small" style={{ padding: "0 8px 0 0" }} />
            <ListItemText primary={renderBadge(s)} disableTypography />
          </MenuItem>
        ))}
      </Popover>
    </div>
  );
};

export default StatusFilterHeader;
